// A COLLECTION: a hand-ordered set of posts, by name.
//
// The membership lives on the collection row (@common/schema/blog-collection)
// and is joined to the published copies when the page is composed; nothing
// here changes as posts come and go. The template is the site's collection
// template (`site.blog.templates.collection`) — see @common/schema/site/blog.
export const schema = [
  {
    id: "/Page/Element/Type/BlogPostCollection",
    type: "object",
    properties: {
      collectionId: {
        label: "Collection",
        type: "string",
        default: "",
      },
      postRoute: {
        label: "Post page route",
        $ref: "/Page/Route",
        default: "/blog/:slug",
      },
    },
    required: [],
  },
];
